import styled, { css } from 'styled-components';
export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  height: calc(100%);
  padding: 2rem;
  padding-bottom: 0rem;
  gap: 1rem;
  background: #f3f4f6;
`;
export const Title = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 3rem;
  max-width:700px;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  border-radius: 4px;
  font-size: 1.3rem;
  margin-top: 1.75rem;
  font-weight: bolder;
  background-color: #ffffff;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  border-left: 3px solid #1D86FF;
  > span {
    position: absolute;
    display: flex;
    width: 5rem;
    height: 5rem;
    top: -35px;
    left: 1rem;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    font-size: 1.5rem;
    color: #ffff;
    background-color: #1D86FF;
    box-shadow: rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px
  }
  > div {
    margin-left: 5rem;
  }
`;
export const Button = styled.button`
  outline: none;
  border: none;
  display: flex;
  width: 10rem;
  gap: 0.5rem;
  padding: 0.5rem;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  background-color: #1D86FF;
  color: #ffffff;
  font-size: 14px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  &:hover{
    opacity: 0.9;
  }
`;
export const Content = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.2rem;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  overflow: hidden;
  > div:nth-child(1){
    display: flex;
    gap: .5rem;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    .uFS{
      max-width: 100px;
    };
    .uFN{
      border-radius: 4px;
      max-width: 450px;
      background: transparent;
      border:solid 1px #e8e8e8;
    };
  };
  transition: all 0.33s;
`;

export const ListGroups = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  > div {
    display: flex;
    width: 100%;
    min-height: 2rem;
    background: #ecedef;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 0.5rem;
    }

    > div:nth-child(1) {
      flex: 1;
    }

    > div:nth-child(2) {
      flex: 3;
    }
  }

  > ul {
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
    }

    > li {
      display: flex;
      width: 100%;
      min-height: 3.5rem;
      align-items: center;
      background-color: #ffffff;
      border-bottom: 1px solid #dadce0;
      padding: 0 0.5rem;
      cursor: pointer;
      transition: background 0.2s;

      &:hover {
        opacity: 0.9;
        background: #1D86FF1a;
        cursor: pointer;

        > span:nth-child(3) {
          color: #1D86FF;
        }
      }

      &.selected {
        background: #1D86FF1a;

        > span:nth-child(3) {
          color: #1D86FF;
        }
      }

      > p {
        display: flex;
        height: 2rem;
        justify-content: center;
        align-items: center;
        padding: 0 0.5rem;
      }

      > p:nth-child(1) {
        flex: 1;
      }

      > p:nth-child(2) {
        justify-content: flex-start;
        border-left: 2px solid #ecedef;
        flex: 3;
        max-height: 5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      > span {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 2.5rem;
        height: 2.5rem;
        margin-left: auto;
        color: transparent;
        transition: color 0.2s;

        &:hover {
          color: #1D86FF; 
        }
      }
    }
  }
`;
export const DetailsGroup = styled.div`
  display: flex;
  width: 100%;
  height: ${({ expandir }) => expandir ? '3rem' : '0px'};
  overflow: hidden;
  align-items: center;
  justify-content: center;
  transition: all 0.33s;
  ${({ expandir }) => expandir && css`
    min-height: 3rem;
  `}
  .Ds-none {
    display:none;
  }
`;
export const ConfigGroup = styled.div`
  width: 100%;
  height: ${({ expandir }) => expandir ? '60rem' : '0px'};
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
  transition: all 0.33s;
  overflow: hidden;
`;